// -----------------------------------------------------------------------------------
// globals
// -----------------------------------------------------------------------------------

var labelList = [];

var nameElementDesktop = document.getElementById("name_link_desktop");

var nameElementLandscape = document.getElementById("name_link_landscape");

var nameElementPortrait = document.getElementById("name_link_portrait");
var prevElementPortrait = document.getElementById("prev_link_portrait") || [];
var nextElementPortrait = document.getElementById("next_link_portrait") || [];

var labelElementDesktop = document.getElementById("labelDesktop");
var labelElementLandscape = document.getElementById("labelLandscape");
var labelElementPortrait = document.getElementById("labelPortrait");

var followersElementDesktop = document.getElementById("followers_desktop");
var followersElementLandscape = document.getElementById("followers_landscape");
var followersElementPortrait = document.getElementById("followers_portrait");

var arrowsWrapperElement = document.getElementById("arrows");
var arrowLeftElement = document.getElementById("arrow-left");
var arrowRightElement = document.getElementById("arrow-right");

var headerElement = document.getElementById("header");
var instaFooterElement = document.getElementById("instaFooter");

var mainWrapper = document.getElementById("main");
var headerWrapper = document.getElementById("Header__Wrapper") || [];
var shareBar = document.getElementById("CatsShare") || [];
var catsFooter = document.getElementById("cats-footer");

var rtDiffuseAlpha;
var diffuseAlphaUniforms;
var diffuseAlphaMaterial;




var isLandscape = false;


// -----------------------------------------------------------------------------------
// texture channels compositor
// -----------------------------------------------------------------------------------

function setupDynamicTextureDiffuseAlpha() {

    var rtWidth = 1024;
    var rtHeight = 1024;

    var rtParamsUByte = {

        "minFilter": XG.LinearMipMapLinearFilter,
        "magFilter": XG.LinearFilter,
        "stencilBuffer": false,
        "format": XG.RGBAFormat,
        "type": XG.UnsignedByteType

    };

    rtDiffuseAlpha = new XG.RenderTarget(rtWidth, rtHeight, rtParamsUByte);
    rtDiffuseAlpha.generateMipmaps = true;
    rtDiffuseAlpha.depthBuffer = false;
    rtDiffuseAlpha.stencilBuffer = false;
    rtDiffuseAlpha.anisotropy = 8;

    diffuseAlphaUniforms = {

        "diffuseMap": { type: "t", value: null },
        "alphaMap": { type: "t", value: null }

    };

    var vertexShader = XG.ShaderChunk["vertexShaderFullscreenTriangleUV"];

    var fragmentShader = [

        "uniform sampler2D diffuseMap;",
        "uniform sampler2D alphaMap;",

        "varying vec2 vUv;",

        "void main() {",

        "vec4 color = texture2D( diffuseMap, vUv );",
        "vec4 alpha = texture2D( alphaMap, vUv );",

        "mgl_FragColor = vec4( color.rgb, alpha.r );",

        "}"

    ].join("\n")

    var diffuseAlphaShader = {

        "fragmentShader": fragmentShader,
        "vertexShader": vertexShader,
        "uniforms": diffuseAlphaUniforms

    };


    diffuseAlphaMaterial = new XG.ShaderMaterial(diffuseAlphaShader);
    diffuseAlphaMaterial.side = XG.DoubleSide;

    diffuseAlphaUniforms["diffuseMap"].value = dummyBlackMap;
    diffuseAlphaUniforms["alphaMap"].value = dummyBlackMap;

}

function updateDiffuseAlphaTexture() {

    var screenScene = XG.EffectComposer.scene;
    var screenCamera = XG.EffectComposer.camera;
    var screenMaterials = XG.EffectComposer.quad.materials;

    screenMaterials[0] = diffuseAlphaMaterial;
    renderer.render(screenScene, screenCamera, rtDiffuseAlpha, false);

}

// -----------------------------------------------------------------------------------
// character
// -----------------------------------------------------------------------------------

function addCharacter() {

    var d = 4.75;
    var nSegments = isMobile ? 100 : 150;
    var aspectRatio = 1;

    var geometry = new XG.HeightfieldGeometry(d * aspectRatio, d, nSegments * 2, nSegments);

    // flip texture Y

    var uvs = geometry.attributes.uv.array;

    for (var i = 0, il = uvs.length; i < il; i += 2) {

        uvs[i + 1] = 1.0 - uvs[i + 1];

    }

    // character material

    characterMaterial = new XG.EmissiveMaterial({ color: 0xffffff });
    characterMaterial.blending = XG.LegacyNormalBlending;

    characterMaterial.map = dummyTransparentMap;
    characterMaterial.transparent = true;

    characterMaterial.displacementMap = dummyBlackMap;
    characterMaterial.displacementBias = 0.0;
    characterMaterial.displacementScale = 1.0;

    // character mesh

    var localRoot = new XG.Node();
    meshRoot.add(localRoot);

    localRoot.scale.multiplyScalar(50);

    characterMesh = new XG.Mesh(geometry, characterMaterial);
    characterMesh.rotation.x = Math.PI * 0.5;
    characterMesh.position.y = 0.0;
    localRoot.add(characterMesh);

    //

    var imgWidth = 1024;
    var imgHeight = 1024;

    var scale = 0.5;

    var tiltX = 0.0;
    var positionY = 0.0;

    //

    var aspectRatio = imgWidth / imgHeight;

    var scaleX = scale * aspectRatio;
    var scaleZ = scale;

    characterMesh.scale.x = scaleX;
    characterMesh.scale.z = scaleZ;

    characterMesh.rotation.x = Math.PI * (0.5 + tiltX);
    characterMesh.position.y = positionY;

    scene.add(meshRoot);

}

// -----------------------------------------------------------------------------------

function setCharacterParameters(index) {

    loadTextures(index);

    var pars = characterList[index];

    // eyes geo

    var leftEyePosition = pars["leftEyePosition"];
    var rightEyePosition = pars["rightEyePosition"];

    leftGyro.position.set(leftEyePosition[0], leftEyePosition[1], leftEyePosition[2]);
    rightGyro.position.set(rightEyePosition[0], rightEyePosition[1], rightEyePosition[2]);

    var eyeScale = pars["eyeScale"];
    var eyeScaleZ = pars["eyeScaleZ"];
    var corneaScaleZ = pars["corneaScaleZ"];

    var leftEyeRotation = pars["leftEyeRotation"];
    var rightEyeRotation = pars["rightEyeRotation"];

    var eyeVisible = pars["loaded"] && pars["eyeVisible"];

    leftEye.visible = eyeVisible;
    rightEye.visible = eyeVisible;

    leftCornea.visible = eyeVisible;
    rightCornea.visible = eyeVisible;

    leftEye.rotation.set(leftEyeRotation[0], leftEyeRotation[1], leftEyeRotation[2]);
    leftEye.scale.set(1, 1, 1).multiplyScalar(eyeScale);
    leftEye.scale.z *= eyeScaleZ;

    rightEye.rotation.set(rightEyeRotation[0], rightEyeRotation[1], rightEyeRotation[2]);
    rightEye.scale.set(1, 1, 1).multiplyScalar(eyeScale);
    rightEye.scale.z *= eyeScaleZ;

    leftCornea.rotation.copy(leftEye.rotation);
    leftCornea.scale.set(1, 1, 1).multiplyScalar(eyeScale);

    rightCornea.rotation.copy(rightEye.rotation);
    rightCornea.scale.set(1, 1, 1).multiplyScalar(eyeScale);
    rightCornea.scale.z *= corneaScaleZ;

    // character geo

    var imgWidth = pars["imgWidth"];
    var imgHeight = pars["imgHeight"];

    var scale = pars["scale"];
    var tiltX = pars["tiltX"];
    var positionY = pars["positionY"];
    var pivotY = pars["pivotY"];

    var aspectRatio = imgWidth / imgHeight;

    var scaleX = scale * aspectRatio;
    var scaleZ = scale;

    characterMesh.scale.x = scaleX;
    characterMesh.scale.z = scaleZ;

    characterMesh.rotation.x = Math.PI * (0.5 + tiltX);
    characterMesh.position.y = positionY;

    meshRoot.position.y = pivotY;

    // character material

    var displacementBias = pars["displacementBias"];
    var displacementScale = pars["displacementScale"];

    characterMaterial.displacementBias = displacementBias;
    characterMaterial.displacementScale = displacementScale;

    var diffuseMap = pars["diffuseMap"];
    var alphaMap = pars["alphaMap"];
    var displacementMap = pars["displacementMap"];

    diffuseAlphaUniforms["diffuseMap"].value = diffuseMap;
    diffuseAlphaUniforms["alphaMap"].value = alphaMap;

    updateDiffuseAlphaTexture();

    //characterMaterial.map = diffuseMap;
    characterMaterial.map = rtDiffuseAlpha;
    characterMaterial.displacementMap = displacementMap;

    // eyes materials

    var eyeMap = pars["eyeMap"];
    var eyeDepthMap = pars["eyeDepthMap"];
    var eyeDepthScale = pars["eyeDepthScale"];

    eyeMaterial.map = eyeMap;
    eyeMaterial.displacementMap = eyeDepthMap;
    eyeMaterial.displacementScale = eyeDepthScale;

    var corneaMap = pars["corneaMap"];
    var corneaIntensity = pars["corneaIntensity"];

    corneaMaterial.map = corneaMap;
    corneaMaterial.intensity = corneaIntensity;

    // borders

    var borderZ = pars["borderZ"];
    var borderRight = pars["borderRight"];
    var borderLeft = pars["borderLeft"];
    var borderTop = pars["borderTop"];
    var borderBottom = pars["borderBottom"];

    borderMeshRight.position.z = borderZ;
    borderMeshRight.position.x = borderRight;

    borderMeshLeft.position.z = borderZ;
    borderMeshLeft.position.x = borderLeft;

    borderMeshTop.position.z = borderZ;
    borderMeshTop.position.y = borderTop;

    borderMeshBottom.position.z = borderZ * 1.25;
    borderMeshBottom.position.y = borderBottom;

    // responsivity

    parameters["headScaleX"] = pars["headScaleX"];
    parameters["headScaleY"] = pars["headScaleY"];

    if (isMobile) {

        if (window.innerWidth > window.innerHeight) {

            parameters["headScaleX"] = 3;
            parameters["headScaleY"] = 4;

        } else {

            parameters["headScaleX"] = 4;
            parameters["headScaleY"] = 2;

        }

    }

    parameters["headVelocity"] = pars["headVelocity"];

    // label

    if (useLabel) {

        if (pars["labelMesh"] === undefined) {

            var labelText = pars["label"];

            var labelCenter = pars["labelCenter"];
            var labelDepth = pars["labelDepth"];
            var labelHeight = pars["labelHeight"];

            var fontSize = pars["labelSize"];
            var labelColor = pars["labelColor"];
            var fontColor = { "h": labelColor[0], "s": labelColor[1], "v": labelColor[2] };

            var label = createLabel(labelText, fontSize, fontColor);

            label.position.x += labelCenter;
            label.position.z = labelDepth;
            label.position.y = labelHeight;

            meshRoot.add(label);

            pars["labelMesh"] = label;

            labelList.push(label);

        }

        // hide all labels

        for (var i = 0, il = labelList.length; i < il; i++) {

            labelList[i].visible = false;

        }

        // show just the current label

        pars["labelMesh"].visible = true;

    }

    //nameElement.innerHTML = "[" + pars[ "srcName" ] + "]";

    var fullName = pars["srcName"];
    var shortName = fullName.split(" ")[0];

    var instaName = "@" + pars["srcLabel"];

    var followersCount = "<b>" + pars["srcCount"] + "</b> followers";

    nameElementDesktop.innerHTML = instaName;
    nameElementDesktop.href = pars["srcLink"];

    nameElementLandscape.innerHTML = instaName;
    nameElementLandscape.href = pars["srcLink"];

    nameElementPortrait.innerHTML = instaName;
    nameElementPortrait.href = pars["srcLink"];

    followersElementDesktop.innerHTML = followersCount;
    followersElementLandscape.innerHTML = followersCount;
    followersElementPortrait.innerHTML = followersCount;

    document.title = fullName + " | Beautiful Cats of Instagram | Tuft + Paw";


    /*if ( pars.id === "nala" ) {

        instaFooterElement.style.top = ( 38 ) + "px";

    } else {*/

    instaFooterElement.style.top = (0) + "px";

    /*}*/


    //

    if (showHash) {

        var id = pars.id;
        setHash(id);

    }

}

// -----------------------------------------------------------------------------------
// permalinks
// -----------------------------------------------------------------------------------

function setHash(a) {

    window.location.hash = a;

}

function getHash(a) {

    var a = a.split("#");
    if (a.length === 2) return a[1];

    return "";

}

// -----------------------------------------------------------------------------------
// textures
// -----------------------------------------------------------------------------------

function generateLoadChecker(index) {

    return function checkLoaded() {

        var pars = characterList[index];

        pars["loadCounter"] += 1;

        if (pars["loadCounter"] >= 6) {

            pars["loaded"] = true;

            if (currentIndex === index) {

                loadingElement.style.display = "none";

                var eyeVisible = pars["eyeVisible"];

                leftEye.visible = eyeVisible;
                rightEye.visible = eyeVisible;

                leftCornea.visible = eyeVisible;
                rightCornea.visible = eyeVisible;

                updateDiffuseAlphaTexture();

            }

        }

    }

}

// -----------------------------------------------------------------------------------

function loadTextures(index) {

    var pars = characterList[index];

    if (!pars["diffuseMap"]) {

        // console.log( "Loading textures for character:", index );

        pars["loadCounter"] = 0;
        var checkLoaded = generateLoadChecker(index);

        var diffuseUrl = pars["diffuseUrl"];
        var alphaUrl = pars["alphaUrl"];
        var displacementUrl = pars["displacementUrl"];

        var eyeUrl = pars["eyeUrl"];
        var corneaUrl = pars["corneaUrl"];
        var eyeDepthUrl = pars["eyeDepthUrl"];

        var diffuseMap = XG.ImageUtils.loadTexture(diffuseUrl, checkLoaded);
        diffuseMap.anisotropy = 8;

        var alphaMap = XG.ImageUtils.loadTexture(alphaUrl, checkLoaded);
        alphaMap.anisotropy = 8;

        var displacementMap = XG.ImageUtils.loadTexture(displacementUrl, checkLoaded);
        //displacementMap.anisotropy = 8;

        var eyeMap = XG.ImageUtils.loadTexture(eyeUrl, checkLoaded);
        eyeMap.anisotropy = 8;
        eyeMap.wrapS = XG.RepeatWrapping;
        eyeMap.repeat.set(2, 1);

        var eyeDepthMap = XG.ImageUtils.loadTexture(eyeDepthUrl, checkLoaded);
        //eyeDepthMap.anisotropy = 8;
        eyeDepthMap.wrapS = XG.RepeatWrapping;
        eyeDepthMap.repeat.set(2, 1);

        var corneaMap = XG.ImageUtils.loadTexture(corneaUrl, checkLoaded);
        corneaMap.anisotropy = 8;
        corneaMap.premultiplyAlpha = true;
        corneaMap.wrapS = XG.RepeatWrapping;
        corneaMap.repeat.set(2, 1);

        pars["diffuseMap"] = diffuseMap;
        pars["alphaMap"] = alphaMap;
        pars["displacementMap"] = displacementMap;

        pars["eyeMap"] = eyeMap;
        pars["eyeDepthMap"] = eyeDepthMap;
        pars["corneaMap"] = corneaMap;

    }

}

// -----------------------------------------------------------------------------------
// eyes
// -----------------------------------------------------------------------------------

function addEyes() {

    leftGyro = new XG.Gyroscope();
    rightGyro = new XG.Gyroscope();

    meshRoot.add(leftGyro);
    meshRoot.add(rightGyro);

    // EYES

    var eyeGeometry = new XG.SphereGeometry(1, 32, 16);

    eyeMaterial = new XG.EmissiveMaterial({ color: 0xffffff });
    eyeMaterial.map = dummyBlackMap;

    eyeMaterial.displacementMap = dummyBlackMap;
    eyeMaterial.displacementScale = 0.0;

    // LEFT EYE

    leftEye = new XG.Mesh(eyeGeometry, eyeMaterial);
    leftGyro.add(leftEye);

    // RIGHT EYE

    rightEye = new XG.Mesh(eyeGeometry, eyeMaterial);
    rightGyro.add(rightEye);

    // CORNEAS

    corneaMaterial = new XG.EmissiveMaterial({ color: 0xffffff });
    corneaMaterial.transparent = true;
    corneaMaterial.blending = XG.AdditiveBlending;
    corneaMaterial.map = dummyBlackMap;

    // LEFT EYE

    leftCornea = new XG.Mesh(eyeGeometry, corneaMaterial);
    leftGyro.add(leftCornea);

    // RIGHT CORNEA

    rightCornea = new XG.Mesh(eyeGeometry, corneaMaterial);
    rightGyro.add(rightCornea);

    //

    leftEye.visible = false;
    rightEye.visible = false;

    leftCornea.visible = false;
    rightCornea.visible = false;

}

// -----------------------------------------------------------------------------------
// borders
// -----------------------------------------------------------------------------------

function addBorders(color) {

    var borderZ = 60;

    var borderRight = 148;
    var borderLeft = -148;

    var borderTop = 97;
    var borderBottom = -90;

    var geoSide = new XG.PlaneGeometry(200, 200);
    var geoTop = new XG.PlaneGeometry(200, 100);

    var mat = new XG.EmissiveMaterial({ "color": color });

    // right

    borderMeshRight = new XG.Mesh(geoSide, mat);
    borderMeshRight.position.z = borderZ;
    borderMeshRight.position.x = borderRight;

    scene.add(borderMeshRight);

    // left

    borderMeshLeft = new XG.Mesh(geoSide, mat);
    borderMeshLeft.position.z = borderZ;
    borderMeshLeft.position.x = borderLeft;

    scene.add(borderMeshLeft);

    // top

    borderMeshTop = new XG.Mesh(geoTop, mat);
    borderMeshTop.position.z = borderZ;
    borderMeshTop.position.y = borderTop;

    scene.add(borderMeshTop);

    // bottom

    borderMeshBottom = new XG.Mesh(geoTop, mat);
    borderMeshBottom.position.z = borderZ * 1.25;
    borderMeshBottom.position.y = borderBottom;

    scene.add(borderMeshBottom);

}

// -----------------------------------------------------------------------------------
// labels
// -----------------------------------------------------------------------------------

function loadFont(font) {

    var map = XG.ImageUtils.loadTexture(font.img);
    map.anisotropy = 16;

    font.map = map;

}

function generateText(text, font, fontSize, fontSmoothness, materialParameters, fontParameters) {

    var textureAtlasInfo = {

        "width": font.width,
        "height": font.height,
        "base": font.base

    };

    var material = new XG.SpriteMaterial({

        "textureAtlas": font.map,
        "billboard": false,
        "antialias": true,
        "transparent": true,
        "sdf": true,
        "fog": materialParameters.fogEnabled,
        "fogDensity": materialParameters.fogDensity,
        "fogColor": materialParameters.fogColor,
        "epsilon": fontSmoothness,
        "side": XG.DoubleSide

    });

    var numSprites = text.length;
    var geometry = new XG.SpriteGeometry(numSprites);

    var metrics = {

        "width": 0,
        "height": 0

    };

    var lineLength = (fontParameters !== undefined && fontParameters.lineLength !== undefined) ? fontParameters.lineLength : 1460;
    var fontColor = (fontParameters !== undefined && fontParameters.color !== undefined) ? fontParameters.color : new XG.Color(0x2c3e59);

    var parameters = {

        "font": font,
        "fontSize": fontSize,
        "wordWrap": true,
        "lineLength": lineLength,
        "lineHeight": 2.3333,
        "color": fontColor

    };

    geometry.setText(text, 0, 0, 0, parameters, metrics);

    var sx = - (metrics.width * 0.5);
    var sy = + (metrics.height * 0.5);
    var sz = 0;

    //sy = -metrics.height;
    sy = 0;
    sz = 0;

    mesh = new XG.Mesh(geometry, material);
    mesh.position.set(sx, sy, sz);

    mesh.castShadow = true;
    mesh.receiveShadow = true;

    return mesh;

}

function createLabel(text, fontSize, color) {

    var fontColor = new XG.Color();
    fontColor.setHSV(color.h, color.s, color.v);

    var fontParameters = {

        lineLength: 1000,
        color: fontColor

    };


    var labelMaterialParameters = {

        "fogEnabled": false,
        "fogDensity": 0.002,
        "fogColor": 0x050505

    };

    var label = generateText(text, sdfBebas, fontSize, 0.1, labelMaterialParameters, fontParameters);

    return label;

}

// -----------------------------------------------------------------------------------
// ui
// -----------------------------------------------------------------------------------

function setDesktop() {

    labelElementDesktop.style.display = "block";
    labelElementLandscape.style.display = "none";
    labelElementPortrait.style.display = "none";

    arrowsWrapperElement.style.display = "block";
    headerElement.style.display = "block";

}

function setArrowsDesktop() {

    var offset = (SCREEN_WIDTH * 0.5 + 100);
    var style = "calc(50% - " + offset + "px)";

    arrowLeftElement.style.left = style;
    arrowRightElement.style.right = style;

    //arrowLeftElement.style.left = "calc(50% - 475px)";
    //arrowRightElement.style.right = "calc(50% - 475px)";

}

function setLandscape() {

    isLandscape = true;

    //setDesktop();
    return;

    labelElementDesktop.style.display = "none";
    labelElementLandscape.style.display = "block";
    labelElementPortrait.style.display = "none";

    arrowsWrapperElement.style.display = "block";
    headerElement.style.display = "none";


}

function setPortrait() {

    isLandscape = false;
    //setLandscape();
    return;

    labelElementDesktop.style.display = "none";
    labelElementLandscape.style.display = "none";
    labelElementPortrait.style.display = "block";

    arrowsWrapperElement.style.display = "none";
    headerElement.style.display = "block";



}


// -----------------------------------------------------------------------------------
// utils
// -----------------------------------------------------------------------------------

function mix(a, b, r) {

    return a + (b - a) * r;

}


// -----------------------------------------------------------------------------------
// update
// -----------------------------------------------------------------------------------

function updateHead(delta) {

    var headSrcX = mouseX;
    var headSrcY = mouseY;

    if (isMobile) {

        var touchScale = 1.0;
        var gyroScale = 10.0;

        var boundX = 480;
        var boundY = 480;

        if (isLandscape) {

            headSrcY = GAMMA_DEG * -gyroScale;
            headSrcX = (BETA_DEG - 0) * gyroScale;

            // landscape bottom left

            if (ORIENTATION === 90) {

                headSrcX *= -1;
                headSrcY *= -1;

            }

            touchScale *= 270 / windowHalfY;

            boundX = 480;
            boundY = 270;

        } else {

            // portrait normal

            headSrcX = GAMMA_DEG * -gyroScale;
            headSrcY = (BETA_DEG - 0) * -gyroScale;

            // portrait inverted

            if (ORIENTATION > 0) {

                headSrcX *= -1;
                headSrcY *= -1;

            }

            touchScale *= 480 / windowHalfX;

            boundX = 480;
            boundY = 480;

        }

        headSrcX = XG.Math.clamp(headSrcX + mouseX * touchScale, -boundX, boundX);
        headSrcY = XG.Math.clamp(headSrcY + mouseY * touchScale * 3, -boundY, boundY);

    }

    var headX = parameters.headScaleX * headSrcX;
    var headY = parameters.headScaleY * headSrcY;

    targetX = headX * 0.000125;
    targetY = headY * 0.000125;

    var deltaHead = delta * parameters.headVelocity;

    meshRoot.rotation.y += deltaHead * (targetX - meshRoot.rotation.y);
    meshRoot.rotation.x += deltaHead * (targetY - meshRoot.rotation.x);

    if (leftEye) {

        var pars = characterList[currentIndex];

        var dy = 0.35;
        var dx = 0.25;

        // left eye

        var leftEyeRY = meshRoot.rotation.y * pars["leftEyeRotationScaleY"] + pars["leftEyeRotationOffsetY"];
        var leftEyeRX = meshRoot.rotation.x * pars["leftEyeRotationScaleX"] + pars["leftEyeRotationOffsetX"];

        leftEyeRY = XG.Math.clamp(leftEyeRY, meshRoot.rotation.y - dy + pars["leftEyeRotationOffsetY"], meshRoot.rotation.y + dy + pars["leftEyeRotationOffsetY"]);
        leftEyeRX = XG.Math.clamp(leftEyeRX, meshRoot.rotation.x - dx + pars["leftEyeRotationOffsetX"], meshRoot.rotation.x + dx + pars["leftEyeRotationOffsetX"]);

        leftEye.rotation.y = leftEyeRY;
        leftEye.rotation.x = leftEyeRX;

        // right eye

        var rightEyeRY = meshRoot.rotation.y * pars["rightEyeRotationScaleY"] + pars["rightEyeRotationOffsetY"];
        var rightEyeRX = meshRoot.rotation.x * pars["rightEyeRotationScaleX"] + pars["rightEyeRotationOffsetX"];

        rightEyeRY = XG.Math.clamp(rightEyeRY, meshRoot.rotation.y - dy + pars["rightEyeRotationOffsetY"], meshRoot.rotation.y + dy + pars["rightEyeRotationOffsetY"]);
        rightEyeRX = XG.Math.clamp(rightEyeRX, meshRoot.rotation.x - dx + pars["rightEyeRotationOffsetX"], meshRoot.rotation.x + dx + pars["rightEyeRotationOffsetX"]);

        rightEye.rotation.y = rightEyeRY;
        rightEye.rotation.x = rightEyeRX;

        //

        var dy = 0.35;
        var dx = 0.25;

        // left cornea

        var leftCorneaRY = meshRoot.rotation.y * pars["leftCorneaRotationScaleY"] + pars["leftCorneaRotationOffsetY"];
        var leftCorneaRX = meshRoot.rotation.x * pars["leftCorneaRotationScaleX"] + pars["leftCorneaRotationOffsetX"];

        leftCorneaRY = XG.Math.clamp(leftCorneaRY, meshRoot.rotation.y - dy + pars["leftCorneaRotationOffsetY"], meshRoot.rotation.y + dy + pars["leftCorneaRotationOffsetY"]);
        leftCorneaRX = XG.Math.clamp(leftCorneaRX, meshRoot.rotation.x - dx + pars["leftCorneaRotationOffsetX"], meshRoot.rotation.x + dx + pars["leftCorneaRotationOffsetX"]);

        leftCornea.rotation.y = leftCorneaRY;
        leftCornea.rotation.x = leftCorneaRX;

        //

        var rightCorneaRY = meshRoot.rotation.y * pars["rightCorneaRotationScaleY"] + pars["rightCorneaRotationOffsetY"];
        var rightCorneaRX = meshRoot.rotation.x * pars["rightCorneaRotationScaleX"] + pars["rightCorneaRotationOffsetX"];

        rightCorneaRY = XG.Math.clamp(rightCorneaRY, meshRoot.rotation.y - dy + pars["rightCorneaRotationOffsetY"], meshRoot.rotation.y + dy + pars["rightCorneaRotationOffsetY"]);
        rightCorneaRX = XG.Math.clamp(rightCorneaRX, meshRoot.rotation.x - dx + pars["rightCorneaRotationOffsetX"], meshRoot.rotation.x + dx + pars["rightCorneaRotationOffsetX"]);

        rightCornea.rotation.y = rightCorneaRY;
        rightCornea.rotation.x = rightCorneaRX;

    }

}
